import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { PageHeader, Toast } from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { STAGE_BADGE } from "./StaffDepartments";

const errText = (e) => e?.response?.data?.detail || "Eroare";
const f1 = (n) => (Math.round((n || 0) * 100) / 100).toString();

/** Plata cu ora: departamentele unui an universitar, cu orele rămase de acoperit (posturi vacante, temporar vacante, rezervate). */
export default function PhDepartments() {
  const [params, setParams] = useSearchParams();
  const { has } = useAuth();
  const [years, setYears] = useState(null);
  const [data, setData] = useState(null);
  const [msg, setMsg] = useState({ text: "", type: "info" });
  const yearId = params.get("year") || (years && (years.find(y => y.is_current) || years[0] || {}).id) || "";

  useEffect(() => { api.get("/stat-didactic/years").then(r => setYears(r.data)).catch(() => setYears([])); }, []);
  useEffect(() => {
    if (!yearId) return;
    setData(null);
    api.get("/stat-didactic/ph/departments", { params: { year_id: yearId } }).then(r => setData(r.data))
      .catch(e => { setData({ departments: [], error: errText(e) }); setMsg({ text: errText(e), type: "error" }); });
  }, [yearId]);

  if (years === null) return <div>Se încarcă...</div>;
  if (years.length === 0) return <div className="card" style={{ padding: 24 }}>Nu există niciun an universitar. Creează-l din <Link to="/stat-didactic/ani">Ani universitari</Link>.</div>;
  return (
    <>
      <PageHeader title="Plata cu ora" subtitle="Orele posturilor vacante, temporar vacante și rezervate din statele de funcții: candidați, punctaj, clasament, atribuire" />
      <Toast msg={msg.text} type={msg.type} />
      <div style={{ display: "flex", gap: 12, alignItems: "flex-end", flexWrap: "wrap", marginBottom: 14 }}>
        <div style={{ minWidth: 220 }}>
          <label className="label">An universitar</label>
          <select className="select" value={yearId} onChange={e => setParams({ year: e.target.value })} data-testid="sfd-ph-year">
            {years.map(y => <option key={y.id} value={y.id}>{y.name}</option>)}</select>
        </div>
        <Link className="btn btn-secondary" to="/stat-didactic/plata-ora/candidati" data-testid="sfd-ph-link-candidates">Candidați externi</Link>
        {has("stat_didactic.ph_params") && <Link className="btn btn-secondary" to={`/stat-didactic/plata-ora/configurari?year=${yearId}`} data-testid="sfd-ph-link-params">Configurări (tarife, punctaje)</Link>}
      </div>
      {!data ? <div>Se încarcă...</div> : data.error ? (
        <div className="card" style={{ padding: 24 }} data-testid="sfd-ph-error">{data.error} <Link to="/stat-didactic/setari">Deschide Setările</Link></div>
      ) : data.departments.length === 0 ? <div className="card" style={{ padding: 24, color: "#64748B" }}>Nu există departamente la nivelul ales în Setări.</div> : (
        <div className="card">
          <table className="tbl" data-testid="sfd-ph-departments">
            <thead><tr><th>Departament</th><th>Starea statului</th><th className="tabular-nums">Discipline cu ore libere</th><th className="tabular-nums">Linii de ore</th><th className="tabular-nums">Atribuite</th><th className="tabular-nums">Neatribuite</th><th className="tabular-nums">Ore convenționale</th><th className="tabular-nums">Candidaturi</th><th></th></tr></thead>
            <tbody>{data.departments.map(d => (
              <tr key={d.id} data-testid={`sfd-ph-dept-${d.name}`}>
                <td style={{ fontWeight: 600 }}>{d.path}</td>
                <td><span className={"badge " + (STAGE_BADGE[d.stage] || "badge-draft")}>{d.stage_label}</span></td>
                <td className="tabular-nums">{d.disciplines}</td><td className="tabular-nums">{d.rows}</td><td className="tabular-nums">{d.assigned_rows}</td>
                <td className="tabular-nums" style={{ color: d.unassigned_rows ? "#B91C1C" : undefined, fontWeight: d.unassigned_rows ? 700 : 400 }}>{d.unassigned_rows}</td>
                <td className="tabular-nums">{f1(d.conventional)}</td><td className="tabular-nums">{d.applications}</td>
                <td><Link className="btn btn-secondary" style={{ padding: "3px 10px", fontSize: 12 }} to={`/stat-didactic/plata-ora/${d.id}?year=${yearId}`} data-testid={`sfd-ph-open-${d.name}`}>Deschide</Link></td>
              </tr>))}</tbody>
          </table>
        </div>)}
    </>
  );
}
